import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SAVE_INGREDIENTS_MUTATION } from '../graphql/mutations'
import { transformToSaveIngredientsArgs } from '../graphql/transformers'
import { SAVE_INGREDIENTS } from '../redux/action-types'

const useSaveIngredientsMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.ingredients.ingredients,
  )

  const mutate = useCallback(
    async data => {
      await apolloService.mutate(
        SAVE_INGREDIENTS_MUTATION,
        { data: transformToSaveIngredientsArgs(data) },
        dispatch,
        SAVE_INGREDIENTS,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useSaveIngredientsMutation
